

import React from "react";
import { Route, Redirect } from "react-router-dom";

const RoleProtectedRoute = ({component, roles, role, ...rest}: any) => {
    const routeComponent = (props: any) => (
        roles.includes(role) 
            ? React.createElement(component, rest)
            : <Redirect to={{pathname: '/login'}}/>
    );
    return <Route {...rest} render={routeComponent}/>;
    }

export default RoleProtectedRoute;